export const formatFileName = (fileName) => {
  return fileName.replaceAll(" ", "_").toLowerCase();
};
